module.exports = __webpack_public_path__ + "static/media/example_01.f333672.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/example_01.mp4
// module id = 5rvj
// module chunks = 1